import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/guides/umre-rehberi-hero.webp")